import { render, staticRenderFns } from "./DownloadReport.vue?vue&type=template&id=0c5a98f4"
import script from "./DownloadReport.vue?vue&type=script&lang=js"
export * from "./DownloadReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports